<template>
  <div ref="collapse">
    <slot>
      <slot name="label" v-bind="{ toggle, isOpen }" />
      <div class="overflow-y-hidden">
        <SlideInFromTopTransition delay-in="delay-200">
          <slot v-if="!isOpen" name="collapsed" />
        </SlideInFromTopTransition>
        <SlideInFromTopTransition delay-in="delay-200">
          <slot
            v-if="isOpen"
            name="collapse-content"
            v-bind="{ toggle, close }"
          />
        </SlideInFromTopTransition>
      </div>
    </slot>
  </div>
</template>

<script setup lang="ts">
import { useTemplateRef, ref } from 'vue'
import SlideInFromTopTransition from '#layers/base/components/ui/transitions/SlideInFromTopTransition.vue'

const collapseRef = useTemplateRef<HTMLElement>('collapse')
const isOpen = ref(false)

const close = () => {
  isOpen.value = false
}
const toggle = () => {
  isOpen.value = !isOpen.value
}

onClickOutside(collapseRef, close)
</script>
